module.exports = __webpack_public_path__ + "img/pci.5fb2d3d3.svg";